import { render, staticRenderFns } from "./TrailLinkDialog.vue?vue&type=template&id=6d1a970e"
import script from "./TrailLinkDialog.vue?vue&type=script&lang=js"
export * from "./TrailLinkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1a970e')) {
      api.createRecord('6d1a970e', component.options)
    } else {
      api.reload('6d1a970e', component.options)
    }
    module.hot.accept("./TrailLinkDialog.vue?vue&type=template&id=6d1a970e", function () {
      api.rerender('6d1a970e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TrailLinkDialog.vue"
export default component.exports